$(function () {
    const mobileNav = $('.mobile-nav');
    const menuBtn = $('.mobile-top-header .menu-btn');
    const closeMobileNav = $('.close-mobile-nav');

    // Open mobile nav when the menu button is clicked
    menuBtn.on('click', function () {
        mobileNav.addClass('active');
    });

    // Close mobile nav when the close button is clicked
    closeMobileNav.on('click', function () {
        mobileNav.removeClass('active');
    });

    $('.mobile-nav').on('click', '.toggler', function (e) {
        e.stopPropagation();

        const $dropdown = $(this).children('.dropdown');

        if ($(e.target).is('a') || $(e.target).closest('a').length) {
            return;
        }

        // If visible, slide up. If hidden, slide down.
        if ($dropdown.is(':visible')) {
            $(this).removeClass('active');
            $dropdown.stop(true, true).slideUp();
        } else {
            $(this).addClass('active');
            $dropdown.stop(true, true).slideDown();
        }
    });
});
